import { createFeatureSelector, createSelector } from '@ngrx/store';
import { templateAdapter } from './template.entity';
import { TemplateState, templateFeatureKey } from './template.state';


export const getTemplateFeature = createFeatureSelector<TemplateState>(templateFeatureKey);

export const { selectAll, selectEntities, selectIds, selectTotal } = templateAdapter.getSelectors()

export const getTemplates = createSelector(getTemplateFeature, selectAll);

export const getTemplate = (id: string) => createSelector(getTemplateFeature, (state) => state.entities[id]);

export const getStudentTemplates = createSelector(getTemplates, (templates) =>
  templates.filter((template) => template.type === 'Student')
);

export const getInstructorTemplates = createSelector(getTemplates, (templates) =>
  templates.filter((template) => template.type === 'Instructor')
);
export const getTemplateBySlug = (slug: string) =>
  createSelector(getTemplates, (state) => {
    return state.find((template) => template.slug === slug);
  });

export const getClassroomFilter = createSelector(getTemplateFeature, (state) => state.classroomFilter);
export const getClassroomCourses = createSelector(getTemplateFeature, (state) => state.classrooms);
export const getError = createSelector(getTemplateFeature, (state) => state.error);
